import {
  type MovieGeoIndexResponse,
  type KilopostResponse,
  toMovieGeoIndex,
  toKilopost,
} from 'src/models/apis/movie/movieResponse';
import type { SensorData, MtxMovie, Mtx } from 'src/models/mtx';

export interface SensorDataResponse {
  movie_id: number;
  start_ts: string;
  ds: number[];
  vs: number[];
  xs: number[];
  ys: number[];
  zs: number[];
}

export type MtxFetchByMovieIdsResponse = SensorDataResponse[];

export interface MtxMovieResponse {
  device_id: string;
  duration: string;
  id: number;
  lat: string;
  lon: string;
  movie_group_id: number;
  start_ts: string;
  movie_geo_indices: MovieGeoIndexResponse[];
}

export interface MtxResponse {
  id: number;
  device_id: string;
  movie_id: number;
  ts: string;
  lat: string;
  lon: string;
  is_place_filled: boolean;
  kp_uid: string | null;
  sensor_data: string | null;
  kilopost: KilopostResponse;
}

export interface MtxFetchByDeviceIdResponse {
  mtxs: MtxResponse[];
  movies: MtxMovieResponse[];
}

export const toSensorData = (response: SensorDataResponse): SensorData => ({
  movieId: response.movie_id,
  startTs: response.start_ts,
  ds: response.ds,
  vs: response.vs,
  xs: response.xs,
  ys: response.ys,
  zs: response.zs,
});

export const toMtxMovie = (response: MtxMovieResponse): MtxMovie => ({
  deviceId: response.device_id,
  duration: response.duration,
  id: response.id,
  location: { lat: response.lat, lon: response.lon },
  movieGroupId: response.movie_group_id,
  startTs: response.start_ts,
  movieGeoIndices: response.movie_geo_indices.map(toMovieGeoIndex),
});

export const toMtx = (response: MtxResponse): Mtx => ({
  id: response.id,
  deviceId: response.device_id,
  movieId: response.movie_id,
  ts: response.ts,
  location: { lat: response.lat, lon: response.lon },
  isPlaceFilled: response.is_place_filled,
  kpUid: response.kp_uid,
  sensorData: response.sensor_data,
  kilopost: toKilopost(response.kilopost),
  // showTimestamp はAPIレスポンスに含まれず、表示時にクライアント側で切り替えるフラグのため初期値 false
  showTimestamp: false,
});
